// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard';
import MainSettings from './pages/Settings/MainSettings';
import ChangePassword from './pages/Settings/ChangePassword';
import MaintenanceMode from './pages/Settings/MaintenanceMode';
import Withdraw from './pages/Settings/Withdraw';
import WithdrawalHistory from './pages/Settings/WithdrawalHistory';
import ProtectedRoute from './components/ProtectedRoute'; // Import this

// Import User Management Pages
import SuperDistributors from './pages/Users/SuperDistributors';
import Distributors from './pages/Users/Distributors';
import Retailers from './pages/Users/Retailers';
import Users from './pages/Users/Users';

// Import Report Pages
import SuperDistributorReport from './pages/Reports/SuperDistributorReport';
import DistributorReport from './pages/Reports/DistributorReport';
import RetailerReport from './pages/Reports/RetailerReport';
import UserReport from './pages/Reports/UserReport';

// Import Transaction Pages
import PointTransfer from './pages/Transactions/PointTransfer';
import PointWithdrawalRequests from './pages/Transactions/PointWithdrawalRequests';

import GameTimeSetting from './pages/Game/GameTimeSetting';
import GameAutoResult from './pages/Game/GameAutoResult';
import GameManualResult from './pages/Game/GameManualResult';

import BetHistory from './pages/History/BetHistory';
import ResultHistory from './pages/History/ResultHistory';
import GameRoundHistory from './pages/History/GameRoundHistory';

import AddBalance from './pages/Settings/AddBalance'; // Add this import


const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) return <div className="text-center py-5">Loading...</div>;
  
  return user ? children : <Navigate to="/login" />;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Route */}
      <Route path="/login" element={<Login />} />
      
      {/* Dashboard */}
     <Route
  path="/dashboard"
  element={
    <ProtectedRoute>
      <Layout>
        <Dashboard />
      </Layout>
    </ProtectedRoute>
  }
/>
      
      {/* ==================== User Management Routes ==================== */}
      <Route
        path="/users/super-distributors"
        element={
          <PrivateRoute>
            <Layout>
              <SuperDistributors />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/users/distributors"
        element={
          <PrivateRoute>
            <Layout>
              <Distributors />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/users/retailers"
        element={
          <PrivateRoute>
            <Layout>
              <Retailers />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/users/list"
        element={
          <PrivateRoute>
            <Layout>
              <Users />
            </Layout>
          </PrivateRoute>
        }
      />
      
      {/* ==================== Report Routes ==================== */}
      <Route
        path="/reports/super-distributor"
        element={
          <PrivateRoute>
            <Layout>
              <SuperDistributorReport />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/reports/distributor"
        element={
          <PrivateRoute>
            <Layout>
              <DistributorReport />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/reports/retailer"
        element={
          <PrivateRoute>
            <Layout>
              <RetailerReport />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/reports/users"
        element={
          <PrivateRoute>
            <Layout>
              <UserReport />
            </Layout>
          </PrivateRoute>
        }
      />
      
      {/* ==================== Transaction Routes ==================== */}
      <Route
        path="/transactions/transfer/:userType?"
        element={
          <PrivateRoute>
            <Layout>
              <PointTransfer />
            </Layout>
          </PrivateRoute>
        }
      />
      
    <Route
  path="/transactions/withdrawals/:role"
  element={
    <PrivateRoute>
      <Layout>
        <PointWithdrawalRequests />
      </Layout>
    </PrivateRoute>
  }
/>
      
      {/* ==================== Settings Routes ==================== */}
      <Route
        path="/settings/main"
        element={
          <PrivateRoute>
            <Layout>
              <MainSettings />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/change-password"
        element={
          <PrivateRoute>
            <Layout>
              <ChangePassword />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/settings/maintenance"
        element={
          <PrivateRoute>
            <Layout>
              <MaintenanceMode />
            </Layout>
          </PrivateRoute>
        }
      />
      
      {/* Withdrawal Routes */}
      <Route
        path="/settings/withdraw"
        element={
          <PrivateRoute>
            <Layout>
              <Withdraw />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/withdrawals/history"
        element={
          <PrivateRoute>
            <Layout>
              <WithdrawalHistory />
            </Layout>
          </PrivateRoute>
        }
      />
      
      {/* Game Management Routes */}
      <Route
        path="/game/time-setting"
        element={
          <PrivateRoute>
            <Layout>
              <GameTimeSetting />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/game/auto-result"
        element={
          <PrivateRoute>
            <Layout>
              <GameAutoResult />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/game/manual-result"
        element={
          <PrivateRoute>
            <Layout>
              <GameManualResult />
            </Layout>
          </PrivateRoute>
        }
      />
      
      {/* ==================== History Routes ==================== */}
      <Route
        path="/bets/history"
        element={
          <PrivateRoute>
            <Layout>
              <BetHistory />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/results/history"
        element={
          <PrivateRoute>
            <Layout>
              <ResultHistory />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/games/round-history"
        element={
          <PrivateRoute>
            <Layout>
              <GameRoundHistory />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
  path="/settings/add-balance"
  element={
    <PrivateRoute>
      <Layout>
        <AddBalance />
      </Layout>
    </PrivateRoute>
  }
/>
      
      {/* Default Route - Redirect to Dashboard */}
      <Route path="/" element={<Navigate to="/dashboard" />} />
      
      {/* Catch all - Redirect to Dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
        <ToastContainer 
          position="top-left"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </Router>
    </AuthProvider>
  );
}

export default App;